import styled from 'styled-components';

import { ContentCard } from 'src/app/components/lib/content-card/content-card';
import { Page } from 'src/app/components/lib/page';
import { PaginationControlContainer } from 'src/app/components/lib/table/footer/footer-rebrand.styles';
import { SmallText } from 'src/app/components/lib/typography';

export const CustomPage = styled(Page)`
  margin-left: 0 !important;
  margin-right: 0 !important;
`;

export const GridContainer = styled.div`
  display: grid;
  padding: 0 var(--sizes-100);
  grid-template-columns: repeat(5, 1fr);
  column-gap: var(--sizes-80);
  row-gap: var(--sizes-80);
  width: calc(100% + 2 * var(--sizes-100));
  margin-left: calc(-1 * var(--sizes-100));
  margin-right: calc(-1 * var(--sizes-100));
  overflow: visible;

  /* Large screens - 4 columns */
  @media (max-width: 1550px) {
    grid-template-columns: repeat(4, 1fr);
    column-gap: var(--sizes-70);
    row-gap: var(--sizes-70);
  }

  /* Medium screens (tablets) - 3 columns */
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: var(--sizes-40) var(--sizes-60);
  }

  /* Small screens - 2 columns */
  @media (max-width: 800px) {
    grid-template-columns: auto auto;
    margin-left: 0;
    margin-right: 0;
    justify-content: center;
  }

  /* Mobile screens - 1 column */
  @media (max-width: 600px) {
    grid-template-columns: auto;
    column-gap: 0;
    margin-left: 0;
    margin-right: 0;
    justify-items: center;
  }
`;

export const TemplateCardWrapper = styled.div`
  cursor: pointer;
  transition: box-shadow 0.2s ease;
  border-radius: 8px;
  max-width: 245px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* Make max width on smaller screens */
  @media (max-width: 800px) {
    width: 245px;
  }
`;

export const TemplatePreview = styled.div<{ disabled?: boolean }>`
  height: 280px;
  overflow: hidden;
  background: var(--color-gray-20);
  padding: var(--sizes-60);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  transition: all 0.2s ease;

  &:hover {
    transform: ${({ disabled }) => (disabled ? 'none' : 'translateY(-2px)')};
    box-shadow: ${({ disabled }) => (disabled ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.1)')};
  }
`;

export const SkeletonTemplatePreview = styled(TemplatePreview)`
  align-items: center;
  justify-content: center;
`;

export const HtmlPreviewIframe = styled.iframe`
  width: calc(100% / 0.35);
  height: 1200px;
  border: none;
  background: white;
  zoom: 0.35;
  transform-origin: top left;
  pointer-events: none;
`;

export const TemplateFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--sizes-30);
  min-height: 50px;
  border-top: 1px solid #e0e0e0;
  background: white;
`;

export const TemplateName = styled(SmallText)`
  flex: 1;
  margin-right: var(--sizes-20);
  text-align: left;
  font: var(--font-regular-14pt-semibold);
`;

export const MoreButton = styled.button`
  background: none;
  border: 1px solid var(--color-gray-70);
  cursor: pointer;
  padding: var(--sizes-10);
  border-radius: var(--sizes-10);
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--sizes-60);
  height: var(--sizes-60);

  &:hover {
    background-color: var(--color-grayscale-light-gray);
  }
`;

export const PageContent = styled.div`
  width: 100%;
  flex: 1;
`;

export const StyledContentCard = styled(ContentCard)`
  height: 100%;
  border-radius: var(--sizes-30);
  overflow: hidden;

  .content-card--card-content-article {
    padding: 0 !important;
  }
`;

export const SkeletonCard = styled(TemplateCardWrapper)`
  /* Hide 4th card on large screens (3 columns) */
  &:nth-child(4) {
    @media (max-width: 1200px) {
      display: none;
    }
  }

  /* Hide 3rd and 4th cards on medium screens (2 columns) */
  &:nth-child(n + 3) {
    @media (max-width: 1024px) {
      display: none;
    }
  }

  /* Hide 2nd, 3rd, and 4th cards on small screens (1 column) */
  &:nth-child(n + 2) {
    @media (max-width: 640px) {
      display: none;
    }
  }
`;

export const NoResultsWrapper = styled.div`
  position: relative;
  min-height: 400px;
  width: 100%;
`;

export const StyledPaginationControlContainer = styled(PaginationControlContainer)`
  border-top: 1px solid #e0e0e0;
  padding: var(--sizes-40) var(--sizes-20);
  margin-top: var(--sizes-60);
  margin-left: calc(-1 * var(--sizes-100));
  margin-right: calc(-1 * var(--sizes-100));
  width: calc(100% + 2 * var(--sizes-100));
  justify-content: space-between;
  padding-left: var(--sizes-100);
  padding-right: var(--sizes-100);

  @media (max-width: 1024px) {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }

  @media (max-width: 640px) {
    margin-left: calc(-1 * var(--sizes-60));
    margin-right: calc(-1 * var(--sizes-60));
    width: calc(100% + 2 * var(--sizes-60));
  }
`;

export const RightSideControls = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sizes-20);
`;
